//魔方云
export const fliggyRouter = [
  {
    path: '/service/fliggy/goodsDelivery',
    name: 'GoodsDelivery',
    component: () => import('@/views/service/serviceProvider/fliggy/GoodsDelivery'),
    meta: {
      title: '商品推送',
      keepAlive: false
    }
  },
  {
    path: '/service/fliggy/directOrders',
    name: 'DirectOrders',
    component: () => import('@/views/service/serviceProvider/fliggy/DirectOrders'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/fliggy/addReductionRecord',
    name: 'AddReductionRecord',
    component: () => import('@/views/service/serviceProvider/fliggy/AddReductionRecord'),
    meta: {
      title: '加减价记录',
      keepAlive: false
    }
  },
  {
    path: '/service/fliggy/authorizationCodeBinding',
    name: 'AuthorizationCodeBinding',
    component: () => import('@/views/service/serviceProvider/fliggy/AuthorizationCodeBinding'),
    meta: {
      title: '授权码绑定',
      keepAlive: false
    }
  },
  {
    path: '/service/fliggy/batchAddOnSale',
    name: 'BatchAddOnSale',
    component: () => import('@/views/service/serviceProvider/fliggy/BatchAddOnSale'),
    meta: {
      title: '批量加减价',
      keepAlive: false
    }
  }
]